import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AnalyticalLedgerAccountTransaction  {
    _originalTypeClassName = "zERP.BO.AnalyticalLedgerAccountTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AnalyticalLedgerAccountTransaction.translate = translateService;
}
this.Debit = null;
this.Credit = null;
this.CurrentDebit = null;
this.CurrentCredit = null;
this.BalanceDebit = null;
this.BalanceCredit = null;
this.Description = null;
this.Date = null;
this.AccountId = null;
this.AccountCode = null;
this.AccountDescription = null;
this.AnalyticalLedgerAccountTransactionKey = null;
this._key = this.AnalyticalLedgerAccountTransactionKey = 0; 
}

static translate: TranslateService;
_key: any;
Debit:any;
Credit:any;
CurrentDebit:any;
CurrentCredit:any;
BalanceDebit:any;
BalanceCredit:any;
Description:any;
Date:any;
AccountId:any;
AccountCode:any;
AccountDescription:any;
private _AnalyticalLedgerAccountTransactionKey:any;
get AnalyticalLedgerAccountTransactionKey(): any {
    return this._AnalyticalLedgerAccountTransactionKey;
  }
set AnalyticalLedgerAccountTransactionKey(value: any) {
    this._AnalyticalLedgerAccountTransactionKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AnalyticalLedgerAccountTransactionKey == null || $this.AnalyticalLedgerAccountTransactionKey == 0;
            }


}